import { render, staticRenderFns } from "./PensionDoctor.vue?vue&type=template&id=0e304c2f&"
import script from "./PensionDoctor.vue?vue&type=script&lang=js&"
export * from "./PensionDoctor.vue?vue&type=script&lang=js&"
import style0 from "./PensionDoctor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports